
  var _styles = {
  "unused-free-order-main-card__container": {
    "width": "9.36rem",
    "height": "6.02667rem",
    "borderRadius": "0.48rem",
    "flexDirection": "column",
    "justifyContent": "flex-start",
    "alignItems": "center",
    "overflow": "hidden",
    "position": "relative"
  },
  "unused-free-order-main-card__background": {
    "position": "absolute",
    "top": "0.02667rem",
    "left": "0.02667rem",
    "width": "9.30667rem",
    "height": "5.97333rem",
    "borderRadius": "0.48rem",
    "zIndex": 0
  },
  "unused-free-order-main-card__wrapper": {
    "width": "9.36rem",
    "height": "6.02667rem",
    "position": "relative",
    "zIndex": 1,
    "borderRadius": "0.48rem",
    "flexDirection": "column",
    "justifyContent": "flex-start",
    "alignItems": "center"
  },
  "unused-free-order-main-card__city-wrapper": {
    "marginTop": "0.32rem",
    "width": "100%",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "unused-free-order-main-card__city-img": {
    "width": "0.42667rem",
    "height": "0.42667rem"
  },
  "unused-free-order-main-card__city-text": {
    "marginLeft": "0.16rem",
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.37333rem",
    "fontWeight": "500"
  },
  "unused-free-order-main-card__title-wrapper": {
    "marginTop": "0.29333rem",
    "width": "100%",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "unused-free-order-main-card__title-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.4rem",
    "textAlign": "center"
  },
  "unused-free-order-main-card__amount-wrapper": {
    "width": "100%",
    "overflow": "visible",
    "flexDirection": "row",
    "alignItems": "baseline",
    "justifyContent": "center",
    "marginTop": "0.04rem"
  },
  "unused-free-order-main-card__amount-prefix": {
    "color": "rgb(255,45,25)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.8rem"
  },
  "unused-free-order-main-card__amount-content": {
    "color": "rgb(255,45,25)",
    "fontFamily": "MT New Digital Display",
    "fontWeight": "700",
    "fontSize": "1.6rem"
  },
  "unused-free-order-main-card__biz-line-wrapper": {
    "marginTop": "-0.24rem",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "unused-free-order-main-card__biz-line-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "fontWeight": "400"
  },
  "unused-free-order-main-card__biz-line-icon": {
    "width": "0.37333rem",
    "height": "0.37333rem"
  },
  "unused-free-order-main-card__first-come-text": {
    "marginTop": "0.05333rem",
    "color": "rgb(153,153,153)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.29333rem",
    "fontWeight": "400",
    "textAlign": "center"
  },
  "unused-free-order-main-card__btn-wrapper": {
    "marginTop": "0.29333rem",
    "width": "5.33333rem",
    "height": "1.52rem",
    "position": "relative",
    "alignItems": "flex-end",
    "justifyContent": "flex-end"
  },
  "unused-free-order-main-card__use-button": {
    "width": "5.33333rem",
    "height": "1.28rem",
    "borderRadius": "0.8rem",
    "justifyContent": "center",
    "alignItems": "center",
    "backgroundColor": "rgb(255,231,77)"
  },
  "unused-free-order-main-card__use-button-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.48rem",
    "textAlign": "center"
  },
  "unused-free-order-main-card__badge": {
    "position": "absolute",
    "top": 0,
    "right": 0,
    "height": "0.48rem",
    "paddingTop": 0,
    "paddingRight": "0.21333rem",
    "paddingBottom": 0,
    "paddingLeft": "0.21333rem",
    "borderRadius": "0.32rem 0.26667rem 0.26667rem 0.10667rem",
    "backgroundColor": "rgb(255,106,0)",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "unused-free-order-main-card__badge-text": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "fontWeight": "500"
  },
  "unused-free-order-main-card__expire-desc-wrapper": {
    "marginTop": "0.18667rem",
    "width": "100%",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "unused-free-order-main-card__expire-desc-text": {
    "fontWeight": "400",
    "color": "rgb(153,153,153)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "textAlign": "center"
  },
  "unused-free-order-main-card__notice-slider-wrapper": {
    "width": "100%",
    "height": "0.85333rem",
    "position": "absolute",
    "bottom": 0
  },
  "used-free-order-main-card__container": {
    "width": "9.36rem",
    "borderRadius": "0.32rem",
    "position": "relative",
    "overflow": "hidden"
  },
  "used-free-order-main-card__background": {
    "position": "absolute",
    "top": "0.02667rem",
    "left": "0.02667rem",
    "width": "9.30667rem",
    "height": "2.77333rem",
    "borderRadius": "0.32rem",
    "zIndex": 1
  },
  "used-free-order-main-card__wrapper": {
    "position": "relative",
    "zIndex": 1,
    "flexDirection": "column",
    "alignItems": "flex-start",
    "paddingTop": "0.32rem",
    "paddingRight": "0.32rem",
    "paddingBottom": "0.26667rem",
    "paddingLeft": "0.32rem"
  },
  "used-free-order-main-card__info-row": {
    "width": "100%",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-between"
  },
  "used-free-order-main-card__title": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.42667rem",
    "marginRight": "0.21333rem",
    "maxWidth": "6.13333rem"
  },
  "used-free-order-main-card__amount-wrapper": {
    "flexDirection": "row",
    "alignItems": "baseline",
    "flexShrink": 0
  },
  "used-free-order-main-card__amount-label": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.32rem",
    "marginRight": "0.02667rem"
  },
  "used-free-order-main-card__amount-prefix": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.32rem",
    "marginRight": "0.02667rem"
  },
  "used-free-order-main-card__amount-content": {
    "color": "rgb(17,17,17)",
    "fontFamily": "MT New Digital Display",
    "fontWeight": "700",
    "fontSize": "0.53333rem",
    "maxWidth": "2.66667rem"
  },
  "used-free-order-main-card__milestone-row": {
    "width": "9.36rem",
    "marginLeft": "-0.32rem",
    "marginTop": "0.08rem",
    "flexDirection": "row",
    "alignItems": "center",
    "position": "relative"
  },
  "used-free-order-main-card__milestone-track": {
    "position": "absolute",
    "top": "0.2rem",
    "left": "12.5%",
    "right": "12.5%",
    "height": "0.05333rem",
    "backgroundColor": "rgb(221,221,221)",
    "zIndex": 0
  },
  "used-free-order-main-card__milestone-track--arrived": {
    "position": "absolute",
    "top": "0.2rem",
    "left": "12.5%",
    "height": "0.05333rem",
    "backgroundColor": "rgb(255,45,25)",
    "zIndex": 1
  },
  "used-free-order-main-card__milestone-item": {
    "flex": 1,
    "height": "1.33333rem",
    "flexDirection": "column",
    "justifyContent": "flex-start",
    "alignItems": "center",
    "position": "relative",
    "zIndex": 2
  },
  "used-free-order-main-card__milestone-dot--arrived": {
    "width": "0.42667rem",
    "height": "0.42667rem"
  },
  "used-free-order-main-card__milestone-dot--pending": {
    "width": "0.42667rem",
    "height": "0.42667rem",
    "borderRadius": "0.21333rem",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "used-free-order-main-card__milestone-dot--pending-dot": {
    "width": "0.26667rem",
    "height": "0.26667rem",
    "borderRadius": "0.21333rem",
    "backgroundColor": "rgb(221,221,221)"
  },
  "used-free-order-main-card__milestone-label": {
    "marginTop": "0.13333rem",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "fontWeight": "400",
    "textAlign": "center"
  },
  "used-free-order-main-card__milestone-label--current": {
    "marginTop": "0.13333rem",
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "fontWeight": "600",
    "textAlign": "center"
  },
  "used-free-order-main-card__milestone-time": {
    "color": "rgb(153,153,153)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "fontWeight": "400",
    "textAlign": "center"
  }
};



  module.exports = _styles;
  